import React from 'react'
import { Link } from 'react-router-dom'
import VipLayout from '../../../components/vip/VipLayout'

const AiCompliancePage: React.FC = () => {
  return (
    <VipLayout>
      <main>
        <section className="hero">
          <div className="container">
            <span className="kicker">AI Compliance & Filing</span>
            <h1>AI 资质与备案咨询</h1>
            <p>围绕 AI 算法备案、AI 大模型登记、AI 大模型备案，以及开源大模型私有化部署、企业知识库训练与微调等场景，提供技术理解与合规判断并重的咨询支持。</p>
            <div className="anchor-nav">
              <a href="#algorithm-filing">算法备案</a>
              <a href="#model-registration">大模型登记 / 备案</a>
              <a href="#private-deploy">私有化部署与训练微调</a>
            </div>
          </div>
        </section>
        <section className="section" id="algorithm-filing">
          <div className="container two-col">
            <div>
              <h2 className="section-title">AI 算法备案咨询</h2>
              <p className="section-desc">适用于推荐排序、生成合成、深度合成、智能问答等算法服务场景。</p>
            </div>
            <div className="card content-card">
              <ul className="list">
                <li>算法备案适用性判断</li>
                <li>算法类型与服务场景梳理</li>
                <li>算法安全自评估材料辅导</li>
                <li>系统填报与补正问询支持</li>
              </ul>
            </div>
          </div>
        </section>
        <section className="section" id="model-registration">
          <div className="container two-col">
            <div className="card content-card">
              <ul className="list">
                <li>自研 / 微调 / 调用 API 路径判断</li>
                <li>AI 大模型登记与备案边界判断</li>
                <li>安全评估与治理机制材料辅导</li>
                <li>模型名称、公示与上线信息整理</li>
              </ul>
            </div>
            <div>
              <h2 className="section-title">AI 大模型登记 / 备案咨询</h2>
              <p className="section-desc">适用于面向公众或外部客户提供生成式 AI 服务的企业，包括自研模型、微调模型及应用层产品场景。</p>
            </div>
          </div>
        </section>
        <section className="section" id="private-deploy">
          <div className="container">
            <h2 className="section-title">私有化部署与训练微调咨询</h2>
            <div className="grid cols-3" style={{marginTop: '24px'}}>
              <div className="card content-card">
                <h3>开源模型私有化部署</h3>
                <p className="lead" style={{fontSize: '15px'}}>围绕 Qwen、DeepSeek、LLaMA 等模型的私有化部署路径与资源方案提供建议。</p>
                <Link className="btn btn-secondary" to="/vip/ai-solutions/private-deployment">查看解决方案</Link>
              </div>
              <div className="card content-card">
                <h3>企业知识库构建</h3>
                <p className="lead" style={{fontSize: '15px'}}>帮助企业梳理产品文档、FAQ、制度资料与行业知识，建立知识中枢。</p>
              </div>
              <div className="card content-card">
                <h3>训练与微调咨询</h3>
                <p className="lead" style={{fontSize: '15px'}}>围绕数据来源、数据整理、训练方式、微调策略与合规风险提供建议。</p>
                <Link className="btn btn-secondary" to="/vip/ai-solutions/training-and-finetuning">查看解决方案</Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    </VipLayout>
  )
}

export default AiCompliancePage
